<div class="container">
  <div class="row ">
    <div class=" col-lg-12">
      <h3>Energielieferverträge von {{currentUser?.person?.displayName}}</h3>
      <div class="row marginBottom2Rem" [formGroup]="filterForm">
        <div class="col-sm-3">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Status</mat-label>
            <mat-select formControlName="filterByStates" multiple="true">
              <mat-select-trigger>
                <span *ngIf="this.filterForm.controls.filterByStates.value != null ">
                  {{this.filterForm.controls.filterByStates.value | translateFilterContract :
                  'filterByStates'}}
                </span>
                <span *ngIf="this.filterForm.controls.filterByStates.value?.length > 1"
                  >
                  (+{{this.filterForm.controls.filterByStates.value.length - 1 }}
                  {{this.filterForm.controls.filterByStates.value?.length === 2 ? 'anderer'
                  :'andere' }})
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let sortOption of supplyContractState"
                [value]="sortOption.value">{{sortOption.viewValue}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-3">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Vertragstyp</mat-label>
            <mat-select formControlName="filterByTypes" multiple="true">
              <mat-select-trigger>
                <span *ngIf="this.filterForm.controls.filterByTypes.value != null ">
                  {{this.filterForm.controls.filterByTypes.value | translateFilterContract :
                  'filterByTypes'}}
                </span>
                <span *ngIf="this.filterForm.controls.filterByTypes.value?.length > 1"
                  >
                  (+{{this.filterForm.controls.filterByTypes.value.length - 1 }}
                  {{this.filterForm.controls.filterByTypes.value?.length === 2 ? 'anderer'
                  :'andere' }})
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let sortOption of SupplyContractType"
                [value]="sortOption.value">{{sortOption.viewValue}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-12">

          <button mat-button mat-raised-button color="accent" (click)="filterContracts()">
            Anwenden
          </button>

          <button mat-button mat-raised-button color="primary" (click)="resetFilter()" style="margin-left: 15px;"
            [disabled]="!this.filterForm.touched">
            Filter zurücksetzen
          </button>
        </div>
      </div>

      <div class="mat-elevation-z2">

      <table mat-table [dataSource]="dataSource" >
        <ng-container matColumnDef="count">
          <th mat-header-cell *matHeaderCellDef> # </th>
          <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
            {{i+1}}
          </td>
        </ng-container>



        <ng-container matColumnDef="contractType">
          <th mat-header-cell *matHeaderCellDef> Vertragstyp </th>
          <td mat-cell *matCellDef="let element" class="mat-column">
            <mat-chip-set>
              <mat-chip color="primary" selected *ngIf="element.contractType == 'POWER'">
                Strom
              </mat-chip>
              <mat-chip color="primary" selected *ngIf="element.contractType == 'GAS' ">
                Gas
              </mat-chip>
            </mat-chip-set>

          </td>
        </ng-container>

        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef> Vertragsnr </th>
          <td mat-cell *matCellDef="let element" class="mat-column"> {{element.number}} </td>
        </ng-container>



        <ng-container matColumnDef="measuringPointNumber">
          <th mat-header-cell *matHeaderCellDef> Zählernr </th>
          <td mat-cell *matCellDef="let element" class="mat-column"> {{element.measuringPointNumber}} </td>
        </ng-container>

        <ng-container matColumnDef="validFrom">
          <th mat-header-cell *matHeaderCellDef> Gültig von </th>
          <td mat-cell *matCellDef="let element" class="mat-column"> {{element.validFrom | date : 'dd.MM.YYYY'}} </td>
        </ng-container>

        <ng-container matColumnDef="validUntil">
          <th mat-header-cell *matHeaderCellDef> Gültig bis </th>
          <td mat-cell *matCellDef="let element" class="mat-column">
            {{ element.validUntil ? (element.validUntil | date : 'dd.MM.YYYY') : '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="contractState">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element" class="mat-column">
            <mat-chip-set>
              <mat-chip color="accent" selected *ngIf="element.contractState == 'RUNNING'">
                Läuft
              </mat-chip>
              <mat-chip color="accent" selected *ngIf="element.contractState == 'CANCELLED' ">
                Gekündigt
              </mat-chip>
              <mat-chip color="accent" selected *ngIf="element.contractState == 'FINISHED' ">
                Beendet
              </mat-chip>
            </mat-chip-set>

          </td>
        </ng-container>
        <ng-container matColumnDef="locallyManaged">
          <th mat-header-cell *matHeaderCellDef> Nicht ändern </th>
          <td mat-cell *matCellDef="let element" class="mat-column">
            <mat-chip color="primary" selected *ngIf="element.locallyManaged">
              <mat-icon>check</mat-icon>
            </mat-chip>
            <mat-chip color="accent" selected *ngIf="!element.locallyManaged">
              <mat-icon>close</mat-icon>
            </mat-chip>
          </td>

        </ng-container>

        <ng-container matColumnDef="menu">
          <th mat-header-cell *matHeaderCellDef class="mat-column">
            Aktion
          </th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu" color="accent">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item [routerLink]="['edit', element.supplyContractRef]">
                <span>Bearbeiten</span>
              </button>
              <button mat-menu-item (click)="delete(element)">
                <span>Löschen</span>
              </button>
              <button mat-menu-item [matMenuTriggerFor]="locallyManaged">Nicht ändern</button>
              <mat-menu #locallyManaged="matMenu">
                <button mat-menu-item (click)="editContractForUser(element,true)">
                  <span>Ja</span>
                </button>
                <button mat-menu-item (click)="editContractForUser(element,false)">
                  <span>Nein</span>
                </button>
              </mat-menu>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
      </table>
      <span *ngIf="dataSource?.data.length === 0" class="emptyTableState">Keine passenden Einträge
        gefunden</span>
      <mat-paginator [length]="page.totalElements" class="paginator-centered " [pageSize]="page.size"
        [pageIndex]="page.number" (page)="loadPage($event)" [pageSizeOptions]="[12, 24, 36, 48]" *ngIf="page">
      </mat-paginator>
    </div>
    </div>

  </div>
</div>

<div class="container" *ngIf="loading">
  <div class="row">
    <div class="col-sm-12 padding">
      <div class="loadingOverlay">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </div>
</div>

<button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['add']">
  <mat-icon>add</mat-icon>
</button>